const LinkedInPageAnalytics = () => (
  <div style={{ marginTop: 20 }}>
    <h4>Page Analytics</h4>
    <ul>
      <li>Impressions: 12,430</li>
      <li>Engagement rate: 4.8%</li>
      <li>Reactions: 124</li>
      <li>Comments: 18</li>
    </ul>
  </div>
);

export default LinkedInPageAnalytics;
